// Builds the shared "Member / Manager" dropdown options from the member/manager master
// lists, which are period-independent. Turning a selected value into a query lives in
// utils/effortOwnerParams.js — the rows now arrive already filtered by the server.
// @since NEXT_VERSION
import { MANAGER_OPTION_PREFIX, dedupeByPerson } from "utils/managerSubtree";
import { sortByLabel } from "utils/optionSort";

// Which id a member option carries. The reports resolve a person to their membership
// id(s) server-side and so select on userId; the timesheet export names one membership
// directly and so selects on the member record's own id. The two id spaces overlap
// numerically, which is why the caller has to say which one it means.
// @since NEXT_VERSION
export const MEMBER_VALUE_USER_ID = "userId";
// @since NEXT_VERSION
export const MEMBER_VALUE_MEMBER_ID = "id";

// members: [{ userId, id, name, ... }]; managers: [{ userId, id, name, ... }] (may be []).
// Member option value = userId by default (falls back to member id); manager value = "MGR-<id>".
export const buildUserOptions = ({
  members = [],
  managers = [],
  memberValue = MEMBER_VALUE_USER_ID,
} = {}) => {
  // Each optgroup is sorted on its own: they render under separate headings, so ordering
  // them together would only interleave two lists the user never sees as one.
  const memberOptions = sortByLabel(
    dedupeByPerson(members).map((m) => ({
      value: String(memberValue === MEMBER_VALUE_MEMBER_ID ? m.id : m.userId ?? m.id),
      label: m.name,
    }))
  );
  const managerOptions = sortByLabel(
    dedupeByPerson(managers).map((mgr) => ({
      value: `${MANAGER_OPTION_PREFIX}${mgr.id}`,
      label: mgr.name,
    }))
  );
  return { memberOptions, managerOptions };
};
